<template>
  <div>
   <el-button type="info" @click="clickpost">提交</el-button>
   <div id="allmap" class="bm-view"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      map: null,
      zoom: 21,
      stepindex: 0
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.map = new BMapGL.Map('allmap')
      var point = new BMapGL.Point(119.90125, 31.814908)
      this.map.centerAndZoom(point, this.zoom)
      this.map.enableScrollWheelZoom(true)

      var that = this
      var scaleCtrl = new BMapGL.ScaleControl() // 添加比例尺控件
      this.map.addControl(scaleCtrl)
      var zoomCtrl = new BMapGL.ZoomControl() // 添加比例尺控件
      this.map.addControl(zoomCtrl)
      var navi3DCtrl = new BMapGL.NavigationControl3D() // 添加3D控件
      this.map.addControl(navi3DCtrl)
      this.map.addEventListener('click', function (e) {
      })
      this.map.addEventListener('rightclick', function (e) {
      })
    },
    clickpost () {
      this.apiFind100RSLPT()
    },
    drawMarker (lng, lat, direction, devicename) {
      var imagesize = 64
      var myIcon = new BMapGL.Icon('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/arrow4.png', new BMapGL.Size(imagesize, imagesize), {
        anchor: new BMapGL.Size(imagesize / 2, imagesize / 2),
        imageOffset: new BMapGL.Size(0, 0)
      })
      var marker = new BMapGL.Marker(new BMapGL.Point(lng, lat), { icon: myIcon })
      this.map.addOverlay(marker)

      marker.setRotation(direction)
      marker.setTitle(devicename)
      marker.setLabel(devicename)
    },
    apiFind100RSLPT: function () {
      var that = this
      var data = {
        os: 'web'
      }
      axios.post(Vue.prototype.global.Url_Find100RSLPT, Qs.stringify(data))
        .then(function (response) {
          that.map.clearOverlays()
          response.data.filter((item, i) => {
            if (i === 0) {
              var point = new BMapGL.Point(item.lng, item.lat)
              that.map.centerAndZoom(point, that.zoom)
            }
            that.drawMarker(item.lng, item.lat, item.direction, item.devicename)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .bm-view {
    width: 100%;
    height: 680px;
  }
</style>
